import { useQuery } from '@tanstack/react-query';
import { getInvoicesIdList } from '../Services/InvoiceService';

const useGetInvoicesIdList = (params, options) =>
    useQuery({
        queryKey: ['getInvoicesIdList', params],
        queryFn: () => getInvoicesIdList(params),
        ...options,
    });

export default useGetInvoicesIdList;
